import Store from '@ember-data/store';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import { tracked } from '@glimmer/tracking';
import { pledgeMonthlyFrequency } from 'donor-elf-web/lib/pledge-utils';
import AbilitiesService from 'donor-elf-web/services/abilities';
import AddSomethingModal, {
  type PledgeSavedArgs,
} from 'donor-elf-web/services/add-something-modal';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import lifecycle from 'donor-elf-web/modifiers/lifecycle';
import { on } from '@ember/modifier';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoNewDonorComponent extends Component<EventInfoComponentArgs> {
  @service declare abilities: AbilitiesService;
  @service declare addSomethingModal: AddSomethingModal;
  @service declare store: Store;

  @tracked canAddPledge = false;
  @tracked pledgeAdded = false;
  savePledgeSubsciptionToken?: string;

  addPledge = () => {
    this.addSomethingModal.open({
      type: 'pledge',
      pledgeOptions: {
        contactId: this.args.eventModel.contactId,
        amount: this.args.eventModel.custom.donation_amount,
        frequency: pledgeMonthlyFrequency,
        startDate: this.args.eventModel.occurredAt,
      },
    });
  }

  loadPledges = async () => {
    if (this.abilities.noAbility('edit_pledges')) {
      this.canAddPledge = false;
      return;
    }
    let pledges = (
      await this.store.query('pledge', {
        filter: { contact_id: this.args.eventModel.contactId },
      })
    ).slice();
    this.canAddPledge = pledges.length === 0;

    if (this.canAddPledge) {
      this.savePledgeSubsciptionToken =
        this.addSomethingModal.subscribeToPledgeSaved(this.handlePledgeSaved);
    }
  }

  handlePledgeSaved = (_msg: string, data: PledgeSavedArgs) => {
    if (
      data.newPledge &&
      data.pledge.contactId === this.args.eventModel.contactId
    ) {
      this.pledgeAdded = true;
      this.canAddPledge = false;
    }
  }

  onLifecycle = () => {
    this.loadPledges();

    return () => {
      if (this.pledgeAdded) {
        this.pledgeAdded = false;
      }
      if (this.savePledgeSubsciptionToken) {
        this.addSomethingModal.unsubscribeWithToken(
          this.savePledgeSubsciptionToken,
        );
      }
    }
  }

  <template>
    <div {{lifecycle this.onLifecycle}}>
      They gave their first gift of
      {{formatAmount @eventModel.custom.donation_amount removeNoCents=true}}
      {{#if this.canAddPledge}}
        <div>
          <button
            {{on 'click' this.addPledge}}
            class='btn btn-xs btn-warning mt-2'
            type='button'
          >
            {{svgJar 'plus'}}
            Pledge
          </button>
        </div>
      {{else if this.pledgeAdded}}
        <div class='font-weight-light mt-2'>
          A pledge has been added for this donor
        </div>
      {{/if}}
    </div>
  </template>
}
